import React, { useContext } from "react";
import { Container } from "react-bootstrap";
import DataTable from "../../../components/DataTableComponent/DataTable";
import TopBar from "../../../components/TopBarComponent/Topbar";
import TableBody from "../../../constants/dummyData.json";
import BackArrow from "../../../assets/images/Icons/backArrow.svg";
import { StatusCategoryContext } from "../StatuscategoryView";
import ExcelIcon from "../../../assets/images/Icons/xlIcon.svg";
import "./statusCategory.css";
import { baseURL } from "../../../api/Axios";
import { Spinner } from "react-bootstrap";
import AlertBox from "../../../components/AlertComponent/AlertBox";

const StatusCategory = () => {
  const {
    goBack,
    statusCategory,
    excelDownload,
    zoneNewExcel,
    spinnerStatus,
    logout,
    setShowAlert,
    alertMessage,
    statusCode,
    showAlert,
  } = useContext(StatusCategoryContext);
  const tableContent = TableBody.statusCategory;

  const tableHeader = [
    { title: "Category Name", prop: "categoryName" },
    { title: "Total Count", prop: "totalCount" },
    { title: "PVC Compounding (Zone 1)", prop: "zoneOneCount" },
    { title: "Wires Factory (zone 2)", prop: "zoneTwoCount" },
  ];

  return (
    <div className="category-page">
      <TopBar />
      <Container>
        <div className="heading-row my-3">
          <div className="title-box">
            <img
              className="back-arrow"
              src={BackArrow}
              alt="Back Arrow"
              width={17}
              onClick={() => goBack()}
            />
            <p className="category-title-name">Filtered by Category</p>
          </div>
          <div className="text-align">
            <span className="download-text">
              <a
                className={zoneNewExcel ? "excel-download" : "disabled-button"}
                href={zoneNewExcel ? `${baseURL}/excel/${zoneNewExcel}` : null}
              >
                <img className="excel-icon" src={ExcelIcon} alt="Excel-icon" />
                {spinnerStatus ? <Spinner size="sm" /> : "Download Excel"}
              </a>
            </span>
          </div>
        </div>
        <DataTable
          header={tableHeader}
          tableData={statusCategory?.length > 0 ? statusCategory : []}
          isPagination={false}
        />
      </Container>
      <AlertBox
        show={showAlert}
        setShow={setShowAlert}
        alertMessage={alertMessage}
        handleSubmit={
          statusCode == 401 ? () => logout() : () => setShowAlert(false)
        }
      />
    </div>
  );
};

export default StatusCategory;
